import { css } from 'linaria';
import { styled, StyledComponent } from 'linaria/react';

export const wrapperStyles = css`
  position: relative;
  width: 100%;
`;

export const Container: StyledComponent<{ inScrollNow: boolean }> = styled.div<{ inScrollNow: boolean }>`
  display: flex;
  width: calc(100% + var(--space-250));
  padding-left: var(--space-125);
  margin: -10px 0px -10px -10px;
  overflow-x: scroll;
  scroll-snap-type: ${({ inScrollNow }) => (inScrollNow ? 'none' : 'x proximity')};
  scroll-padding: var(--carousel-scroll-padding, 250px);
  overscroll-behavior-x: contain;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }

  @media (--to-tablet) {
    width: calc(100vw - var(--space-250));
    margin-left: 0;
    scroll-padding: auto;
  }
`;

export const SafariScrollGap = styled.div`
  width: 4px;
`;
